import { useTranslation } from 'react-i18next';

import { Alert } from '@sola/ark-core/molecules/alert/alert.js';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.js';

import { CommitmentAvatarGroup } from '../commitment-avatar-group/commitment-avatar-group';

export enum MakeAPaymentAlertType {
  payAhead,
  paymentDue,
  missingPayment,
}

export interface MakeAPaymentAlertProps {
  alertType: MakeAPaymentAlertType;
  onButtonClick: () => void;
  commitments?: GraphQLCommitment[];
  amountDue?: number;
  className?: string;
}

export const MakeAPaymentAlert = ({
  alertType,
  commitments,
  amountDue,
  className,
  onButtonClick,
}: MakeAPaymentAlertProps) => {
  const { t } = useTranslation(['my', 'common']);
  const variant =
    alertType === MakeAPaymentAlertType.missingPayment ? 'negative' : 'neutral';
  const translationKey = MakeAPaymentAlertType[alertType];
  return (
    <Alert
      className={className}
      noIcon
      mobileCentered
      title={t(`makeAPayment.alerts.${translationKey}.title`)}
      message={t(`makeAPayment.alerts.${translationKey}.message`, {
        amountDue: t('numbers.currencyCustom', {
          amount: amountDue,
        }),
      })}
      middleColumn={
        alertType !== MakeAPaymentAlertType.payAhead &&
        commitments &&
        commitments?.length > 0 && (
          <CommitmentAvatarGroup
            commitments={commitments}
            purpose={variant}
            size="lg"
            tooltipMessage={t(`makeAPayment.alerts.${translationKey}.tooltip`, {
              count: commitments.length,
            })}
          />
        )
      }
      variant={variant}
      buttonAction={
        <button
          onClick={onButtonClick}
          aria-label={t(`makeAPayment.alerts.cta`)}
          type="button"
        >
          {t(`makeAPayment.alerts.cta`)}
        </button>
      }
    />
  );
};
